// Logo inline (mismo SVG que el navbar del shell): self-contained, no depende
// de una imagen externa (la anterior apuntaba a agiotech.com y salía rota).
const LOGO_SVG = `
  <svg viewBox="0 0 58.7 58.7" class="h-9 w-9 shrink-0" fill="none" aria-hidden="true">
    <path fill="#00ACBD" d="M58.7,26.3v6.1C58.7,47,47,58.7,32.4,58.7h-6.1C11.8,58.7,0,47,0,32.4c0-8.3,6.7-15,15-15H19c-2.9,2.5-4.8,6.2-4.8,10.4V31c0,7.5,6.1,13.6,13.6,13.6H31c7.5,0,13.6-6.1,13.6-13.6v-3.2c0-7.5-6.1-13.6-13.6-13.6h-1.6v0H3C7.4,5.7,16.2,0,26.3,0h6.1C47,0,58.7,11.8,58.7,26.3"/>
  </svg>`

export function LoginForm() {
  const year = new Date().getFullYear()
  return `
    <!-- Logo (solo móvil; en desktop vive en el panel teal del hero) -->
    <div class="lg:hidden flex items-center gap-3 mb-10">
      ${LOGO_SVG}
      <span class="font-headline font-bold text-xl text-on-surface tracking-tight">Agio Hub</span>
    </div>

    <p class="font-label text-secondary mb-2">Inicio de sesión</p>
    <h2 class="font-headline font-extrabold text-3xl sm:text-4xl text-on-surface tracking-tight mb-8">
      Entrar al sistema
    </h2>

    <form id="login-form" class="space-y-5 enter enter-delay-2">
      <!-- Correo electrónico -->
      <div>
        <label for="email" class="auth-label">Correo electrónico</label>
        <input
          type="email"
          id="email"
          name="email"
          class="input-auth"
          placeholder="correo@empresa.com"
          autocomplete="username"
          required
        />
      </div>

      <!-- Contraseña -->
      <div>
        <label for="password" class="auth-label">Contraseña</label>
        <input
          type="password"
          id="password"
          name="password"
          class="input-auth"
          placeholder="Ingresa tu contraseña"
          autocomplete="current-password"
          required
        />
      </div>

      <!-- Mantener sesión -->
      <div class="flex items-center gap-2 pt-1">
        <input
          type="checkbox"
          id="remember-me"
          name="remember-me"
          class="h-4 w-4 rounded border-outline-variant accent-primary"
        />
        <label for="remember-me" class="text-sm text-on-surface-variant select-none cursor-pointer">
          Mantener sesión
        </label>
      </div>

      <!-- Submit -->
      <button type="submit" class="btn-auth w-full mt-2" id="login-button">
        <span class="material-symbols-outlined text-base hidden" id="loading-spinner">progress_activity</span>
        <span class="material-symbols-outlined text-base" id="login-icon">login</span>
        <span id="button-text">Entrar</span>
      </button>
    </form>

    <!-- Mensaje de error -->
    <div
      id="error-message"
      class="mt-4 p-3 rounded-xl bg-error-container text-error text-sm hidden"
    >
      <span id="error-text"></span>
    </div>

    <!-- Recuperación -->
    <div class="text-center mt-6">
      <a
        href="/pages/forgot-password.html"
        class="text-sm font-medium text-secondary hover:text-primary hover:underline"
      >
        ¿Olvidaste tu contraseña?
      </a>
    </div>

    <!-- Pie (solo móvil; en desktop el copyright vive en el panel teal) -->
    <p class="lg:hidden text-center text-outline text-xs mt-10">
      Agiotech &copy; Copyright ${year}
    </p>
  `
}

// Conservado para otras pantallas de auth (p. ej. verify-2fa), que lo
// importan como bloque de error independiente. El login NO lo usa: tiene su
// propio `#error-message` inline arriba con los tokens nuevos.
export function ErrorMessage() {
  return `
    <div
      id="error-message"
      class="mt-3 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm hidden"
    >
      <span id="error-text"></span>
    </div>
  `
}
